import type { SVGProps } from 'react'

const P: Record<string, string> = {
  home: 'M3 10.5 12 3l9 7.5M5.5 9.5V20h13V9.5',
  activity: 'M3 12h3l2.5-6 4 13L15 12h6',
  layout: 'M3 5h18v14H3zM3 9.5h18M9 9.5V19',
  layers: 'm12 3 9 5-9 5-9-5 9-5ZM3 13l9 5 9-5',
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  shirt: 'M9 3 4 6l1.5 4L8 9v11h8V9l2.5 1L20 6l-5-3-3 3-3-3Z',
  wand: 'm15 4 5 5M13.5 5.5 3 16l5 5L18.5 10.5 13.5 5.5ZM18 14v6M15 17h6M6 2v4M4 4h4',
  image: 'M3 5h18v14H3zM3 16l5-5 4 4 3-3 6 6M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3',
  film: 'M3 5h18v14H3zM3 9h18M3 15h18M8 5v14M16 5v14',
  video: 'M3 6h12v12H3zM15 10.5 21 7v10l-6-3.5z',
  copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
  text: 'M4 5h16M4 10h11M4 15h16M4 20h8',
  sparkles: 'm12 3 1.9 4.9L19 9.8l-5.1 1.9L12 17l-1.9-5.3L5 9.8l5.1-1.9L12 3ZM18 15l.8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8L18 15Z',
  folder: 'M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z',
  chart: 'M4 20V9M10 20V4M16 20v-7M22 20H2',
  settings: 'M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4ZM19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2 2 2 0 1 1-4 0 1.7 1.7 0 0 0-2.9-1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.7 1.7 0 0 0 3 15a2 2 0 1 1 0-4 1.7 1.7 0 0 0 1.4-2.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.7 1.7 0 0 0 10 4a2 2 0 1 1 4 0 1.7 1.7 0 0 0 2.8 1.4l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1A1.7 1.7 0 0 0 21 11a2 2 0 1 1 0 4 1.7 1.7 0 0 0-1.6 1Z',
  panel: 'M3 5h18v14H3zM9 5v14',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21l-4.3-4.3',
  plus: 'M12 5v14M5 12h14',
  x: 'M6 6l12 12M18 6 6 18',
  check: 'm5 13 4.5 4.5L19 7',
  upload: 'M12 16V4m0 0L7 9m5-5 5 5M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2',
  download: 'M12 4v12m0 0 5-5m-5 5-5-5M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2',
  refresh: 'M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6',
  trash: 'M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13M10 11v6M14 11v6',
  star: 'm12 3.5 2.7 5.6 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1L3.2 10l6.1-.9L12 3.5Z',
  /* 「改名」用（模板中心里给自存模板改名）。笔身 + 一道笔尖分隔线，24 格子里最省笔画的一版 */
  edit: 'M4 20h4L20 8l-4-4L4 16v4ZM14 6l4 4',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12 1v3M12 20v3M4.2 4.2l2.2 2.2M17.6 17.6l2.2 2.2M1 12h3M20 12h3M4.2 19.8l2.2-2.2M17.6 6.4l2.2-2.2',
  type: 'M4 6V4h16v2M12 4v16M8.5 20h7',
  chevron: 'm6 9 6 6 6-6',
  chevronLeft: 'm15 6-6 6 6 6',
  chevronRight: 'm9 6 6 6-6 6',
  play: 'M7 4.5 19 12 7 19.5z',
  /* 播放器的暂停键（模板预览用）。播放是描边三角，暂停就用两条等长竖线对齐它 */
  pause: 'M9 5v14M15 5v14',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v5.2l3.2 2',
  coin: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM15 9.2A4 4 0 0 0 12 8c-2 0-3 .9-3 2s1 1.8 3 2 3 .9 3 2-1 2-3 2a4 4 0 0 1-3-1.2',
  zoom: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM20 20l-4-4M8 11h6M11 8v6',
  expand: 'M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5',
  palette: 'M12 21a9 9 0 1 1 0-18c5 0 9 3.4 9 7.5 0 2.5-2 4.5-4.5 4.5H15a2 2 0 0 0-1.4 3.4A2 2 0 0 1 12 21ZM7.5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10.5 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  watermark: 'M3 5h18v14H3zM7 15l3-4 2.5 3L15 11l2 4',
  eyes: 'M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  scissors: 'M6 6a2.5 2.5 0 1 0 0-1 2.5 2.5 0 0 0 0 1ZM6 19a2.5 2.5 0 1 0 0-1 2.5 2.5 0 0 0 0 1ZM8 7.5 20 19M20 5 8 16.5',
  box: 'm12 3 8 4.5v9L12 21l-8-4.5v-9L12 3ZM4 7.5 12 12l8-4.5M12 12v9',
  book: 'M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2V5ZM19 17H6',
  alert: 'M12 3 2 20h20L12 3ZM12 9v5M12 17.5v.01',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 8v.01M12 11.5V16',
  archive: 'M3 7h18v13H3zM2 3.5h20V7H2zM9.5 11.5h5',
  link: 'M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1',
  shield: 'M12 3 4 6v6c0 5 3.4 8.2 8 9.5 4.6-1.3 8-4.5 8-9.5V6l-8-3Z',
  bolt: 'M13 2 4 14h6l-1 8 9-12h-6l1-8Z',
  users: 'M16 20v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 20v-2a4 4 0 0 0-3-3.9M16.5 2.1a4 4 0 0 1 0 7.8',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3c2.6 2.6 3.9 5.6 3.9 9S14.6 18.4 12 21c-2.6-2.6-3.9-5.6-3.9-9S9.4 5.6 12 3Z',
  // 语音合成（`/tts`）—— 喇叭 + 两道声波。
  // 不复用 `play`：`play` 已经专门指「试听这一条音色」（VoicePreviewButton），
  // 而语音合成页的产出是一段音频文件，语义不同；两处共用一个图标会让
  // 「点这个会先花钱合成」和「点这个放已生成的东西」看起来是一件事。
  wave: 'M11 5 6 9H3v6h3l5 4V5ZM15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13',
  // 声音克隆（`/tts/clone`）—— 话筒 + 底座。
  // ⚠️ **别拿它替 `wave`**：`wave` 是「一段已经存在的音频」（语音合成的产出 / 试听），
  // 而这里是「对着它说话、把声音采下来」，两个动作不是一回事。
  mic: 'M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3ZM5.5 11.5a6.5 6.5 0 0 0 13 0M12 18.5V21M8.5 21h7',
  // 录音停止键。与 `pause` 分开：暂停是「还能接着走」，停止是「这一段录完了」。
  stop: 'M7 7h10v10H7z',
}

export type IconName = keyof typeof P

export function Icon({
  name,
  size = 16,
  strokeWidth = 1.8,
  ...rest
}: { name: IconName; size?: number; strokeWidth?: number } & Omit<SVGProps<SVGSVGElement>, 'name'>) {
  const d = P[name] ?? P.info
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={d} />
    </svg>
  )
}
